const reducer = {
  setFieldContainerApp(state, action) {
    const { field, value } = action.payload ?? {};
    if (field) {
      state[field] = value;
    }
  },
  addItem(state, action) {
    state.list.push(action.payload);
  },
  viewItem(state, action) {
    state.viewItem = action.payload;
  },
};

export default reducer;
